export default (config = {}) => ({
  isOpen: false,
  currentReelIndex: 0,
  reelsData: config.reelsData || [],
  shopLocale: config.shopLocale || 'en',
  shopCurrency: config.shopCurrency || 'USD',
  showMobileProducts: false,

  get currentReel() {
    return this.reelsData[this.currentReelIndex] || null;
  },

  get currentProducts() {
    return this.currentReel?.products || [];
  },

  get currentReelHasProducts() {
    return this.currentProducts.length > 0;
  },

  init() {
    window.addEventListener('open-reels-modal', (event) => {
      this.open(event.detail);
    });
  },

  open(detail) {
    this.currentReelIndex = detail.reelIndex || 0;
    this.isOpen = true;
    this.showMobileProducts = false;

    this.$nextTick(() => {
      this.playCurrentVideo();
    });
  },

  close() {
    this.pauseCurrentVideo();
    this.isOpen = false;
    this.currentReelIndex = 0;
    this.showMobileProducts = false;
  },

  toggleMobileProducts() {
    this.showMobileProducts = !this.showMobileProducts;
  },

  playCurrentVideo() {
    const video = this.$refs.modalVideo;
    if (video) {
      video.play().catch(err => console.log('Video play failed:', err));
    }
  },

  pauseCurrentVideo() {
    const video = this.$refs.modalVideo;
    if (video) {
      video.pause();
    }
  },

  formatPrice(price) {
    return new Intl.NumberFormat(this.shopLocale, {
      style: 'currency',
      currency: this.shopCurrency
    }).format(price / 100);
  },

  openProductQuickView(handle) {
    const product = this.currentProducts.find(p => p.handle === handle);
    if (product && product.url) {
      window.open(product.url, '_blank');
    }
  },

  async addProductToCart(handle) {
    try {
      const product = this.currentProducts.find(p => p.handle === handle);
      if (!product) return;

      const response = await fetch(`/products/${handle}.js`);
      const productData = await response.json();

      if (!productData.variants || productData.variants.length === 0) {
        alert('Product has no available variants');
        return;
      }

      const variantId = productData.variants[0].id;

      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      if (cartResponse.ok) {
        window.dispatchEvent(new CustomEvent('cart:updated'));
        alert(`${product.title} added to cart!`);
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Failed to add product to cart. Please try again.');
    }
  }
});
